<div class="grid grid-nogutter">
    <div class="p-0 col-12 mb-5">
        <h3 class="m-0 h4 mb-2">{{'Invoice Report' | sentenceCase}}</h3>
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-multiSelect [options]="projects" [(ngModel)]="selectedProjects" optionLabel="codeName" placeholder="Project" (onChange)="onProjectSelectionChange($event)" [ngClass]="{'ng-dirty ng-invalid': showProjectSelectionError()}" [resetFilterOnHide]="true" />
        @if(showProjectSelectionError()){
            <span class="p-error pl-1 text-xs">This is required</span>
        }
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-multiSelect [options]="roles" [(ngModel)]="selectedRoles" optionLabel="roleType" placeholder="Role" (onChange)="onRolesSelectionChange($event)" [resetFilterOnHide]="true"/>
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-multiSelect [options]="reviewers" [(ngModel)]="selectedReviewers" optionLabel="fullName" placeholder="Candidate" [resetFilterOnHide]="true"/>
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-0 xl:pr-0 pr-0">
        <p-floatLabel>
            <p-multiSelect 
                inputId="float-label" 
                [options]="moreFilters" 
                [ngModel]="selectedMoreFilters()" 
                (ngModelChange)="selectedMoreFilters.set($event)"
                optionLabel="label" [resetFilterOnHide]="true" />
            <label for="float-label">{{'More Filters' | sentenceCase}}</label>
        </p-floatLabel>
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-dropdown [options]="timezones" [(ngModel)]="selectedTimezone" optionLabel="val" [placeholder]="isDefaultTimeZone ? 'Default timezone' : 'Timezone'" [disabled]="isDefaultTimeZone"  />
    </div>
    <div class="mb-3 xl:col-3 lg:col-4 col-12 lg:pr-3 xl:pr-3 pr-0 flex align-items-center gap-2">
        <p-checkbox 
            [(ngModel)]="isDefaultTimeZone" 
            [binary]="true" 
            inputId="default-tz"
            (onChange)="onChangeDefaultTimezoneCheck($event)" />
        <label for="default-tz">{{'Use Default Timezone' | sentenceCase}}</label>
    </div>
    <div class="mb-3 xl:col-3 lg:col-5 col-12 lg:pr-0 xl:pr-0 pr-0">
        <div class="date-slider flex align-items-center justify-content-between">
            <p-button type="button" pRipple [text]="true" [rounded]="true" [plain]="true" icon="pi pi-chevron-left"
                class="row-toggler" (click)="slider(false)" />
            <span>
                {{getFormattedDateRange()}}
            </span>
            <p-button type="button" pRipple [text]="true" [rounded]="true" [plain]="true" icon="pi pi-chevron-right"
                class="row-toggler" (click)="slider(true)" />
        </div>
    </div>
    <div class="mb-3 ml-0 lg:ml-auto xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-0 pr-0 flex justify-content-start">
        <p-button label="search" [rounded]="true" size="large" (click)="generateReport()" />
    </div>
    @if(invoiceReports().length){
        <div class="flex gap-3 col-12 mb-5 justify-content-end" >
            <p-button label="export pdf" [rounded]="true" size="large" (click)="pdf.toggle($event)"/>
            <p-button label="export csv" [rounded]="true" size="large" (click)="csv.toggle($event)"/>
        </div>
        <div class="flex col-12 gap-4 align-items-center" style="justify-content: space-around;">
            <div class="flex flex-column align-items-center">
                <h5 class="m-0 mb-3">{{'Total Week Hours' | sentenceCase}}</h5>
                <p>{{summary().totalProjectHours}}</p>
            </div>
        </div>
    }
    <div class="p-0 col-12 mt-4">
        <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="invoiceReports()" [paginator]="true" [rows]="2" [tableStyle]="{ 'min-width': '50rem' }"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
            autoLayout="true" [rows]="noOfRows">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        {{'First Name' | sentenceCase}}
                    </th>
                    <th>
                        {{'Last Name' | sentenceCase}}
                    </th>
                    <th>
                        Project
                    </th>
                    <th>
                        Role
                    </th>
                    <th>
                        {{'Total Hours' | sentenceCase}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoiceReport>
                <tr>
                    <td>{{ invoiceReport.firstName }}</td>
                    <td>{{ invoiceReport.lastName }}</td>
                    <td>{{ invoiceReport.projectName }}</td>
                    <td>{{ invoiceReport.roleName }}</td>
                    <td>{{ invoiceReport.totalHours }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-overlayPanel #pdf>
    <div class="flex flex-column gap-3">
        @for(option of reportOptions; track option) {
            <p-button [label]="option.label" [rounded]="true" size="small" (click)="exportPDF(option.key)" [text]="true"/>
        }
    </div>
</p-overlayPanel>

<p-overlayPanel #csv>
    <div class="flex flex-column gap-3">
        @for(option of reportOptions; track option) {
            <p-button [label]="option.label" [rounded]="true" size="small" (click)="exportCSV(option.key)" [text]="true"/>
        }
    </div>
</p-overlayPanel>